import { createSelector } from 'reselect';

import { getPaging, mountSelectorAt } from 'utils/selectors';

const mount = mountSelectorAt('journal');

export const getJournalEmojis = mount(localState => localState.emojis);

export const getJournalCreation = mount(localState => localState.creation);

const getJournalEntriesById = mount(localState => localState.byId);

const getJournalEntriesIdsForPage = mount((localState, props) => {
  const { page } = props;
  const journalEntriesIds = localState.byPage[page];
  if(!journalEntriesIds) {
    return [];
  }

  return journalEntriesIds;
});

export const getJournalEntries = createSelector(
  [getJournalEntriesIdsForPage, getJournalEntriesById],
  (journalEntriesIdsForPage, journalEntriesById) => {
    return journalEntriesIdsForPage.map(key => journalEntriesById[key]);
  }
);

export const getJournalPaging = mount((localState, key, options) => getPaging(localState.paging, options));




/** WEBPACK FOOTER **
 ** ./src/members/state/journal/selectors.js
 **/